
export default function stripHTML(string) {

    return string ? string.replace(/(<([^>]+)>)/gi, "") : '';
};